export enum FormSection {
	patient = 'patient',
	insurance = 'insurance',
}
